// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select[data-v-c1eb7116]{display:block;margin-right:10px}.el-select[data-v-c1eb7116]  .el-input__inner{border-color:transparent!important}.adv_opt.selected[data-v-c1eb7116]{color:#ff3973}.adv_opt.selected[data-v-c1eb7116]:after{content:\"✓\";color:#ff3973;float:right}", ""]);
// Exports
module.exports = exports;
